import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useEvent } from "@hooks/useEvent";
import { Input, Text } from "@fragments";
import { SafetyCheckRounded, AccessTimeRounded } from "@mui/icons-material";
import EVENTS from "../events";

export default function WaitDaysAfterPayment({ value, onChange, initialHasPlans }) {
    const { t } = useTranslation("contentModals");
    const [hasPlans, setHasPlans] = useState(initialHasPlans);
    const [mode, setMode] = useState(value ? 'wait' : 'immediate');
    const [days, setDays] = useState(value || '');

    useEvent(EVENTS.AVAILABILITY_CHANGE, (plans) => {
        setHasPlans(plans && plans.length > 0);
    });

    useEffect(() => {
        if (!hasPlans) {
            // Reset if no plans selected (optional, but good UX to maybe hide or reset)
        }
    }, [hasPlans]);

    function handleModeChange(newMode) {
        console.log(newMode);
        if (!newMode) return;
        setMode(newMode);
        if (newMode === 'immediate') {
            setDays(null);
            onChange(null);
        } else {
            if (days) onChange(days);
            else onChange(null);
        }
    }

    function handleDaysChange(val) {
        if (val && parseInt(val) > 365) {
            val = "365";
        }
        setDays(val);
        onChange(val);
    }

    if (!hasPlans) return null;

    const suggestions = [3, 7, 14, 30].map((days) => ({
        value: days,
        label: t("manageContent.waitDays.suggestionDays", { count: days }),
        icon: <AccessTimeRounded />,
    }));

    return (
        <div className="mt-5">
            <Text.h3
                value={t("manageContent.waitDays.title")}
                left={<SafetyCheckRounded />}
                className="mb-1"
            />

            <Input.Choices
                className="mt-2 mb-2"
                value={mode}
                onInput={handleModeChange}
                options={[
                    { label: t("manageContent.waitDays.immediate"), value: "immediate" },
                    { label: t("manageContent.waitDays.wait"), value: "wait" }
                ]}
            />

            {mode === 'wait' && (
                <div className="pl-2 border-left-surface-7" style={{ borderLeft: "2px solid var(--surface-7)", marginLeft: "8px" }}>
                    <Input.Integer
                        value={days}
                        onInput={handleDaysChange}
                        label={t("manageContent.waitDays.label")}
                        placeholder={t("manageContent.waitDays.placeholder")}
                        maxLength={3}
                        max={3}
                        suggestions={suggestions}
                    />
                </div>
            )}
        </div>
    );
}
